/* eslint-disable arrow-parens */
/* eslint-disable react/prop-types */
import { useState, useRef, useEffect } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { DependentBenefitsProps } from "../../../../../../../types/components/dependentsProps.types";
import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import { dateTimeZoneConverter } from "../../../../../../../utils/commonFunctions/date";
import { handleDateCellRenderer } from "../../../../../../../utils/commonFunctions/cellRenderers";

const DependentBenefitsGrid = ({ benefits }: DependentBenefitsProps) => {
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const [gridHeight, setGridHeight] = useState("300px");
	const agGridRef = useRef(null);

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(Object.assign({}, agGridAPI, api));
		setAgGridColumnAPI(columnApi);
	};

	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handlePlanEndDateCellRenderer = ({ value }: { value: string }) => {
		return <div>{value ? dateTimeZoneConverter(value) : "CURRENT"}</div>;
	};

	useEffect(() => {
		switch (benefits.length) {
			case 0: {
				setGridHeight("210px");
				break;
			}
			case 1: {
				setGridHeight("210px");
				break;
			}
			case 2: {
				setGridHeight("260px");
				break;
			}
			case 3: {
				setGridHeight("300px");
				break;
			}
			case 4: {
				setGridHeight("340px");
				break;
			}
			case 5: {
				setGridHeight("390px");
				break;
			}
			case 6: {
				setGridHeight("440px");
				break;
			}
			case 7: {
				setGridHeight("490px");
				break;
			}
			default:
				setGridHeight("590px");
		}
	}, [benefits.length]);
	// console.log("Benefits", benefits);
	return (
		<div className="dependent-benefit-details-grid-container">
			<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
				<AgGridReact
					ref={agGridRef}
					rowData={benefits}
					onGridReady={handleAgGridReady}
					onFirstDataRendered={handleFirstDataRendered}
					rowSelection={"Single"}
					animateRows
					suppressColumnVirtualisation={true}
					defaultColDef={{
						resizable: true
					}}
					frameworkComponents={{
						handlePlanEndDateCellRenderer: handlePlanEndDateCellRenderer,
						handleDateCellRenderer: handleDateCellRenderer
					}}
				>
					<AgGridColumn field="plan_name" headerName="Plan Name" suppressSizeToFit={true}></AgGridColumn>
					<AgGridColumn field="member.relationship" headerName="Relationship"></AgGridColumn>
					<AgGridColumn
						field="enrollment_date"
						cellRenderer="handleDateCellRenderer"
						headerName="Enrollment Date"
					></AgGridColumn>
					<AgGridColumn
						field="effective_date"
						cellRenderer="handleDateCellRenderer"
						headerName="Effective Date"
					></AgGridColumn>
					<AgGridColumn
						field="plan.end_date"
						cellRenderer="handlePlanEndDateCellRenderer"
						headerName="End Date"
					></AgGridColumn>
				</AgGridReact>
			</div>
		</div>
	);
};

export default DependentBenefitsGrid;
